



























































import { Component, Vue } from 'vue-property-decorator';
import AppModal from '../../shared/components/ui/Modal.vue';
import { Getter, Mutation } from 'vuex-class'
import {ADDFUNDS_IS_OPEN, CLOSE_ADDFUNDS} from "./store/constants";
import addFundsService from "./services/AddFundsService";

import { USERNAME } from "../../modules/auth/store/constants";

@Component({
    components: {
        AppModal,
    },
})
export default class AddFundsSuccess extends Vue {
    @Getter(ADDFUNDS_IS_OPEN) showModal!: boolean;
    @Mutation(CLOSE_ADDFUNDS) closeModal!: Function;
    @Getter(USERNAME) username!: string;

    private close() {
        this.closeModal()
    }

}
